import React, {useCallback, useEffect} from 'react';
import eventBus from "../infrastructure/common/eventBus";
import {useHistory} from "react-router-dom";

export const NavigatorContainer = (props) => {
  const history = useHistory();

  const openFn = useCallback(({detail: {path}}) => {
    history.replace(path);
  }, [history]);

  useEffect(() => {
    eventBus.on('NAVIGATE', openFn);

    return () => {
      eventBus.remove('NAVIGATE', openFn);
    };
  });

  return <div/>;
};

export default React.memo(NavigatorContainer);
